import { SvgIcon, SvgIconProps } from "@mui/material";

export default function ShareIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 26">
      <defs>
        <clipPath id="a">
          <path d="M1440 0v975H0V0h1440z" />
        </clipPath>
        <clipPath id="b">
          <path d="M16.436 2.721c.053.084.092.177.157.301-.35.342-.677.71-1.053 1.019-.585.48-1.35.435-1.954-.066-1.597-1.323-3.159-1.25-4.628.218-1.674 1.673-3.354 3.342-5.02 5.024-.926.936-1.146 2.241-.61 3.416a3.01 3.01 0 0 0 2.889 1.77c.811-.036 1.5-.36 2.075-.935 1.074-1.078 2.158-2.147 3.224-3.232.211-.216.38-.301.695-.192 1.085.377 2.206.482 3.432.309-.121.152-.189.256-.275.343-1.66 1.663-3.313 3.334-4.99 4.982-1.827 1.798-4.44 2.273-6.75 1.261C1.342 15.937-.09 13.654.004 11.104c.055-1.472.57-2.788 1.603-3.843 1.867-1.91 3.731-3.827 5.675-5.659 2.707-2.55 7.215-1.967 9.154 1.119z" />
        </clipPath>
        <clipPath id="c">
          <path d="M16.595 0v17.47H0V0h16.595z" />
        </clipPath>
        <clipPath id="d">
          <path d="M12.21.282c2.232.662 3.657 2.192 4.198 4.462.468 1.968.068 3.817-1.307 5.293-1.911 2.051-3.885 4.055-5.952 5.949-2.644 2.421-7.044 1.778-8.971-1.196-.063-.097-.114-.203-.178-.317.363-.366.69-.758 1.08-1.072.57-.461 1.373-.445 1.902.09 1.13 1.145 3.192 1.342 4.649-.204 1.622-1.722 3.343-3.35 5.006-5.034.926-.936 1.141-2.25.605-3.417a3.002 3.002 0 0 0-2.893-1.764c-.81.036-1.499.362-2.072.938-1.086 1.09-2.17 2.18-3.27 3.256-.116.112-.359.21-.497.167-1.145-.354-2.305-.5-3.569-.33.124-.151.198-.259.288-.35C2.89 5.092 4.53 3.409 6.221 1.777 7.915.142 9.953-.386 12.21.282z" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)" transform="translate(-362 -354)">
        <g clipPath="url(#b)" transform="translate(362.43 362.538)">
          <path fill="#61C2EE" d="M0 0h16.593v17.462H0V0z" />
        </g>
        <g clipPath="url(#c)" transform="translate(371.834 354)">
          <g clipPath="url(#d)">
            <path fill="#61C2EE" d="M0 0h16.595v17.47H0V0z" />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
